
import * as handlebars_family from "../handlebars_family.ts";
import "../nc/signin.mustache";
const TPL = handlebars_family.addTemplate("nc/invitation_error",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression((lookupProperty(helpers,"var")||(depth0 && lookupProperty(depth0,"var"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"error","fw2.defaultError",{"name":"var","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":34}}}))
    + " "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"nc/signin"),depth0,{"name":"nc/signin","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
export default TPL;